import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, ShieldCheck, GraduationCap } from "lucide-react";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const dashboardHref =
    user?.role === "student"
      ? "/app/student"
      : user?.role === "teacher"
      ? "/app/teacher"
      : user?.role === "admin"
      ? "/app/admin"
      : "/login";

  return (
    <header className="glass-header sticky top-0 z-40 border-b border-border" data-testid="site-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3.5">
        <Link to="/" className="flex items-center gap-2.5" data-testid="logo-link">
          <div className="bg-gold-gradient flex h-10 w-10 items-center justify-center rounded-lg shadow-md">
            <GraduationCap className="h-5 w-5 text-white" strokeWidth={2.5} />
          </div>
          <div className="leading-none">
            <div className="font-display text-lg font-bold tracking-tight text-foreground">
              Mowanzi <span className="gold-text-gradient">Academy</span>
            </div>
            <div className="mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground mt-0.5">
              Blockchain · AI · Web3
            </div>
          </div>
        </Link>

        <nav className="hidden items-center gap-8 lg:flex">
          <Link
            to="/courses"
            className="text-sm font-semibold text-foreground/80 hover:text-foreground transition-colors"
            data-testid="nav-courses"
          >
            Courses
          </Link>
          <Link
            to="/verify"
            className="text-sm font-semibold text-foreground/80 hover:text-foreground transition-colors flex items-center gap-1.5"
            data-testid="nav-verify"
          >
            <ShieldCheck className="h-3.5 w-3.5" /> Verify
          </Link>
          <a
            href="#features"
            className="text-sm font-semibold text-foreground/80 hover:text-foreground transition-colors"
            data-testid="nav-features"
          >
            How it works
          </a>
        </nav>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <Button
                variant="outline"
                className="rounded-full border-border font-semibold"
                onClick={() => navigate(dashboardHref)}
                data-testid="header-dashboard-btn"
              >
                Dashboard
              </Button>
              <Button
                variant="ghost"
                className="rounded-full"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                data-testid="header-logout-btn"
              >
                <LogOut className="h-4 w-4 sm:mr-2" />
                <span className="hidden sm:inline">Logout</span>
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="ghost"
                className="rounded-full font-semibold"
                onClick={() => navigate("/login")}
                data-testid="header-login-btn"
              >
                Sign in
              </Button>
              <Button
                className="btn-gold rounded-full font-semibold"
                onClick={() => navigate("/login")}
                data-testid="header-cta-btn"
              >
                Get started
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
